import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'BetterCorpHomeContactUs',
  props: ['country'],
  data: () => {
    return {
      maxPerLine: 4,
      contacts: [
        {
          country: 'za',
          title: 'South Africa',
          lines: [
            {
              title: 'National / WhatsApp',
              link: 'tel://+27872379850',
              text: '+2787 237 9850'
            },
            {
              title: 'Durban',
              link: 'tel://+27310351234',
              text: '+2731 035 1234'
            },
            {
              title: 'Email',
              link: 'mailto:za@bettercorp.co.za',
              text: 'za@bettercorp.co.za'
            }
          ]
        },
        {
          country: 'us',
          title: 'United States',
          lines: [
            {
              title: 'Tel',
              link: 'tel://+18664727011',
              text: '+1866 472 7011'
            },
            {
              title: 'Email',
              link: 'mailto:usa@bettercorp.co.za',
              text: 'usa@bettercorp.co.za'
            }
          ]
        },
        {
          country: 'uk',
          title: 'United Kingdom',
          lines: [
            {
              title: 'Tel',
              link: 'tel://+448450950117',
              text: '+4484 5095 0117'
            },
            {
              title: 'Email',
              link: 'mailto:uk@bettercorp.co.za',
              text: 'uk@bettercorp.co.za'
            }
          ]
        },
        {
          country: 'nz',
          title: 'New Zealand',
          lines: [
            {
              title: 'Tel',
              link: 'tel://+6449748916',
              text: '+644 974 8916'
            },
            {
              title: 'Email',
              link: 'mailto:nz@bettercorp.co.za',
              text: 'nz@bettercorp.co.za'
            }
          ]
        }

      ]
    };
  }
})

export default class BetterCorpContactUs extends Vue {
  get maxPerLineCol() {
    return 12 / (this as any).maxPerLine;
  }
  isNullOrUndefined(val: any) {
    if (val === undefined) return true;
    if (val === null) return true;
  }
  getLines() {
    let lines = [];
    let WorkingLine: any = [];
    let matchCountry = !(this as any).isNullOrUndefined((this as any).country);

    for (let contact of (this as any).contacts) {
      if (WorkingLine.length >= (this as any).maxPerLine) {
        lines.push(WorkingLine);
        WorkingLine = [];
      }

      if (matchCountry) {
        if (contact.country !== (this as any).country) continue;
      }

      WorkingLine.push(contact);
    }

    if (WorkingLine.length > 0)
      lines.push(WorkingLine);

    return lines;
  }
}
